namespace HA.Core.HTML {
    export class WindowHead extends FlexContainer {
        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addClass("wh");
            this.centered();
            const title = new Div(this.get("title"));
            title.addClass("t");

            const cancel = new Div({click : this.get("cancel")});
            cancel.addClass("cancel");
            this.appendChildRight(cancel);
            this.appendChild(title);
            if (this.get("accept")) {
                const accept = new Div({click : this.get("accept")});
                accept.addClass("accept");
                this.appendChildRight(accept);
            }
        }
    }
}
